var e = "11.4.0+unknown";
//#endregion
export { e as REPORT_PACKAGE_VERSION };
